import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import useCartStore from '@/common/stores/CartStore/store';
import theme from '@/common/styles/theme';
import styles from './styles.module.scss';

const Globales = createGlobalStyle`
    .icon-w-text-list__link.cloned {

      @media screen and (max-width: 1199px) {
        display: flex;
        align-items: center;
        height: 100%;
        border-left: 1px solid white;
        border-right: 1px solid white;

        &:after {
          display: none;
        }
      }
    }
`;

const GlobalCartContainer = styled.div`
    color: white;
    position: relative;
    padding: 0 1rem;

    .cloned & {
        @media screen and (min-width: 1200px) {
            display: none;
        }

        .cart-icon-count {
            display: none;
        }

        .icon-w-text {
            display: flex;
            flex-direction: row-reverse;
            align-items: center;
            justify-content: center;
            gap: 0.5rem;

            &__text {
                margin: 0;
            }

            &__icon {
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: ${theme.blue};
                border-radius: 100%;
                width: 36px;
                height: 36px;
            }
        }
    }

    .cart-icon-count {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 100%;
        background-color: white;
        color: ${theme.red};
        position: absolute;
        font-size: 0.65rem;
        height: 14px;
        width: 14px;
        top: -8px;
        right: -7px;

        .offscreen-navigation__inner & {
            color: white;
            background-color: ${theme.blue};
            top: 0;
            right: 0;
        }
    }
`;

const GlobalCartIcon = () => {
    const cart = useCartStore();

    useEffect(() => {
        cart.initializeCart().then(() =>
            console.log('GlobalCartIcon: Cart initialized')
        );
    }, []);

    return (
        <div className={styles.container}>
            <Globales />
            <GlobalCartContainer className="submenu-item__icon">
                <div className="icon-w-text">
                    <div className="icon-w-text__icon">
                        <svg className="icon icon--Detail_ikon_Sort">
                            <use xlinkHref="/sites/stofa.dk/themes/custom/stofacorp/icons_pack/icons.svg#Detail_ikon_Sort"></use>
                        </svg>
                    </div>
                    <div className="icon-w-text__content">
                        <p className="icon-w-text__text paragraph">
                            Kurv ({cart.cart.sections.length})
                        </p>
                    </div>
                </div>

                <div className="cart-icon-count">
                    {cart.cart.sections.length}
                </div>
            </GlobalCartContainer>
        </div>
    );
};

export default observer(GlobalCartIcon);
